module.exports = __webpack_public_path__ + "static/img/enter_banner_iphone_in.f34986d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/enter_banner_iphone_in.png
// module id = whtN
// module chunks = 1